<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :hide-separators="true"
      :title="'Édition des documents personnalisés'"
      :subtitle="`${program ? program.name : ''}`">
    </page-nav-bar>
    <page-content
      :has-left-col-xsmall="true"
      :has-sticky-col-left="true"
      :has-padd-right-normal="true"
      :set-main-col-class="''">
      <template slot="left-col-small">
        <aside class="menu menu--admin">
          <ul class="menu-list has-background-white is-border">
            <li class="is-active">
              <ul>
                <li
                  :class="{'is-active' : panel === 'CUSTOM_DOC_TAB'}"
                  id="tabs-CUSTOM_DOC_TAB">
                  <a @click="panel = 'CUSTOM_DOC_TAB'">
                    <div class="is-uppercase">Notification SRU</div>
                  </a>
                </li>
                <li
                  :class="{'is-active' : panel === 'CUSTOM_CONTRACT'}"
                  id="tabs-CUSTOM_CONTRACT">
                  <a @click="panel = 'CUSTOM_CONTRACT'">
                    <div class="is-uppercase">Contrat de réservation</div>
                  </a>
                </li>
                <li
                  :class="{'is-active' : panel === 'CUSTOM_DOC_ADF'}"
                  id="tabs-CUSTOM_DOC_ADF">
                  <a @click="panel = 'CUSTOM_DOC_ADF'">
                    <div class="is-uppercase">Appel de fonds</div>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </aside>
      </template>
      <div>
        <spinner-round
          :is-loading="loading"
          v-if="loading"></spinner-round>
        <form
          @submit.prevent.stop=""
          v-if="program && !loading">
          <div v-show="panel === 'CUSTOM_DOC_TAB'">
            <div class="has-background-white is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small is-border-bottom">
              <div class="is-size-4 is-uppercase title">
                Documents Personnalisés
              </div>
            </div>
            <div class="has-background-white">
              <div class="columns is-gapless has-background-warning is-marginless">
                <div class="is-size-7 is-padding">
                  <span class="is-uppercase has-text-weight-bold">Personnalisez les documents générés par l'outil en renseignant le logo et les contenus à adapter</span>
                </div>
              </div>
              <div class="is-padding">
                <div class="field is-padding-bottom-large">
                  <r-label
                    :label="'Logo ' + nameToUse"
                    :for-id="''"
                    :is-required="false"
                    :truncate="false">
                    <span
                      class="is-padding-left-xsmall"
                      v-helper.right="'2edQbD16BJhDb8Whv818fN'">
                      <i class="fal fa-info-circle"></i>
                    </span>
                  </r-label>

                  <upload-file
                    :custom-id="'avatar'"
                    @upload="uploadPictures"
                    @deleteDocument="deleteProgramParamsPicture"
                    :source-documents="promoteur_custom_picture"
                    :unique="true"
                    :is-square-input="false"></upload-file>
                </div>
                <div class="field">
                  <r-label
                    :label="'Personnaliser la lettre sru'"
                    :for-id="''"
                    :is-required="false">
                  </r-label>
                  <wysiwyg-editor
                    :model="program.program_params.sru_custom_text"
                    :light-program="true"
                    :light="true"
                    @change="updateComment($event, 'program_params', 'sru_custom_text')"
                    class="has-background-white" />
                </div>
              </div>
            </div>
          </div>
          <div v-show="panel === 'CUSTOM_CONTRACT'">
            <div class="has-background-white is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small is-border-bottom">
              <div class="is-size-4 is-uppercase title">
                Contrat de réservation
              </div>
            </div>
            <div
              v-if="contractName"
              class="columns is-gapless is-marginless has-background-white is-minH64p ">
              <div class="column columns is-self-centered is-padding-left">
                <div
                  class="column is-narrow is-flex is-padding-small is-margin-right-large is-margin-left-large">
                  <span
                    class="icon is-self-centered">
                    <i class="fa-3x fal fa-folder-open"></i>
                  </span>
                </div>
                <div
                  class="is-margin-left-large column is-padding-left-small is-self-centered columns is-gapless is-vcentered is-marginless">
                  <span class="is-5 has-text-weight-bold is-uppercase">
                    Modèle:
                  </span>
                  <span class="is-5 is-padding-left-xsmall">
                    {{ contractName }}
                  </span>
                </div>
              </div>
              <div class="column is-self-centered  is-4 is-narrow">
                <router-link
                  :to="{name: 'ContractCreate', params: {program_id: program.pk}}">
                  <button
                    type="button"
                    class="button is-dark is-fullwidth is-radiusless is-minH64p">
                    <span>Créer un nouveau contrat</span>
                  </button>
                </router-link>
              </div>
            </div>
            <div class="has-background-white">
              <div class="columns is-gapless has-background-warning is-marginless">
                <div class="is-size-7 is-padding">
                  <span class="is-uppercase has-text-weight-bold">Sélectionner le type de contrat que vous souhaitez utiliser.</span>
                </div>
              </div>
            </div>
            <div class="is-padding has-background-white">
              <div class="is-border">
                <div>
                  <div>
                    <div class="row-width-actions-bar is-border-bottom">
                      <div class="columns is-gapless">
                        <div
                          class="column is-narrow is-border-right">
                          <span class="button page-header-btn is-small is-square">
                            <span class="icon is-size-4"><i class="fal fa-file-alt"></i></span>
                          </span>
                        </div>
                        <div class="column is-padding-left-small is-self-centered columns is-gapless is-vcentered is-marginless">
                          <div class="column is-narrow">
                            <input
                              class="is-checkradio is-success"
                              :id="'default-contract'"
                              type="radio"
                              :name="'contract'"
                              @input="useCustomContract = null"
                              :checked="useCustomContract == null">
                            <label
                              class="is-padding-right"
                              :for="'default-contract'"><span
                                class="is-size-6">Contrat par défaut de Vadimm</span></label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <contract-list-item
                    v-for="(contract, idx) in sortedContracts"
                    :source="contract"
                    :current-contract="program.contract_in_use"
                    :key="contract.pk + '-contract'"
                    :index="idx"
                    :program-pk="program.pk"
                    :can-drag="true"
                    :use-custom-contract="useCustomContract"
                    :selected-row="selectedRow"
                    @selectedRow="val => selectedRow = val"
                    @updateContractUsed="updateContractUsed"
                    @remove="removeContract">
                  </contract-list-item>
                </div>
                <div
                  class="">
                  <button
                    @click="openPreviewContractSelect"
                    class="button is-dark is-fullwidth is-radiusless is-minH50p">
                    <span>Ajouter un modèle à la liste</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-show="panel === 'CUSTOM_DOC_ADF'">
            <div class="has-background-white is-border-bottom is-flex is-space-between">
              <div class="is-size-4 is-uppercase title is-padding-top is-padding-left">
                Appel de fonds
              </div>
              <div class="">
                <button
                  @click="openPreview"
                  data-tooltip="Contact(s) non valide"
                  class="button is-minH100 is-dark is-small is-radiusless is-minW154p">
                  <span v-if="!loadingDoc"><span><i class="fas fa-cogs is-margin-xsmall"></i></span><span class="is-size-7">PRÉVISUALISER</span></span>
                  <span v-else><i class="fas fa-spinner fa-spin"></i></span>
                </button>
              </div>
            </div>
            <div class="has-background-white">
              <div class="columns is-gapless has-background-warning is-marginless">
                <div class="is-size-7 is-padding">
                  <span class="is-uppercase has-text-weight-bold">Personnalisez les appels de fonds générés par l'outil sur ce programme</span>
                </div>
              </div>
              <div class="is-padding">
                <div class="field">
                  <r-label
                    :label="'Personaliser le courrier d\'appel de fonds'"
                    :for-id="''"
                    :is-required="false"
                    :truncate="false">
                  </r-label>
                </div>
                <div
                  class="">
                  <custom-mention-section-bloc
                    :min-height="minHeight"
                    :key="'first_section_adf'"
                    :content="program.program_params.first_section_adf"
                    @updateComment="updateComment($event, 'program_params', 'first_section_adf')">
                  </custom-mention-section-bloc>
                </div>
                <div
                  class="is-border is-margin-bottom is-padding-xsmall">
                  OBJET : [ NOM DE LA SOCIÉTÉ DU PROGRAMME ] APPEL DE FONDS - Lot n° [ NOM DU LOT ]
                </div>
                <div
                  class="is-border is-margin-bottom is-padding-xsmall">
                  [ Civilité acquéreur ] ,
                </div>
                <div
                  class="is-border-top is-border-bottom is-margin-bottom">
                  <custom-mention-section-bloc
                    :min-height="minHeight"
                    :key="'home_page_section'"
                    :content="program.program_params.home_page_section"
                    @updateComment="updateComment($event, 'program_params', 'home_page_section')">
                  </custom-mention-section-bloc>
                </div>
                <div
                  class="is-border is-margin-bottom is-padding-xsmall">
                  - Résidence : [ NOM DU PROGRAMME ] <br> - Adresse résidence : [ ADRESSE DU PROGRAMME ]
                </div>
                <div
                  class="is-border-top is-border-bottom is-margin-bottom">
                  <custom-mention-section-bloc
                    :min-height="minHeight"
                    :key="'step_name'"
                    :content="program.program_params.step_name"
                    @updateComment="updateComment($event, 'program_params', 'step_name')">
                  </custom-mention-section-bloc>
                </div>
                <div
                  class="is-border is-margin-bottom is-padding-xsmall is-margin-bottom">
                  [ NOM DE L'ÉTAPE D'APPEL DE FONDS ]
                </div>
                <!-- <div
                  class="is-border-top is-border-bottom is-margin-bottom">
                  <custom-mention-section-bloc
                    :min-height="minHeight"
                    :key="'array_bloc'"
                    :content="program.program_params.array_bloc"
                    @updateComment="updateComment($event, 'program_params', 'array_bloc')">
                  </custom-mention-section-bloc>
                </div> -->
                <div
                  class="is-border is-margin-bottom is-padding-xsmall is-margin-bottom">
                  [ TABLEAU D'APPEL DE FONDS ]
                </div>
                <div
                  class="is-border-top is-border-bottom is-margin-bottom">
                  <custom-mention-section-bloc
                    :min-height="minHeight"
                    :key="'amount_step_adf'"
                    :content="program.program_params.amount_step_adf"
                    @updateComment="updateComment($event, 'program_params', 'amount_step_adf')">
                  </custom-mention-section-bloc>
                </div>
                <div
                  class="is-border is-margin-bottom is-padding-xsmall is-margin-bottom">
                  - Montant : [ MONTANT ATTENDU ]
                </div>
                <div
                  class="is-border-top is-border-bottom is-margin-bottom">
                  <custom-mention-section-bloc
                    :min-height="minHeight"
                    :key="'payment_modality'"
                    :content="program.program_params.modality"
                    @updateComment="updateComment($event, 'program_params', 'modality')">
                  </custom-mention-section-bloc>
                </div>
                <!-- <div
                  class="is-border-top is-border-bottom is-margin-bottom">
                  <custom-mention-section-bloc
                    :min-height="minHeight"
                    :key="'company_name'"
                    :content="program.program_params.company_name_adf"
                    @updateComment="updateComment($event, 'program_params', 'company_name_adf')">
                  </custom-mention-section-bloc>
                </div> -->
              </div>
            </div>
          </div>
          <submit-sticky-buttons
            v-if="hasUpdate"
            @submit="submit"
            :submit-text="'Enregistrer'"
            :loading="submitLoading"
            button-id="programCustomDocForm"></submit-sticky-buttons>
        </form>
      </div>
    </page-content>
  </div>
</template>

<script>
import { DefaultValues, Document } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  name: 'ProgramCustomDocVue',
  components: {
    ContractListItem: () => import('./ContractListItem'),
    CustomMentionSectionBloc: () => import('@/components/contract-matrix/CustomMentionSectionBloc')
  },
  mixins: [DefaultValues, Document],

  data () {
    return {
      blockWatch: true,
      hasUpdate: false,
      id: null,
      selectedRow: null,
      useCustomContract: null,
      promoteur_custom_picture: [],
      program: null,
      loading: false,
      submitLoading: false,
      panel: 'CUSTOM_DOC_TAB',
      text_1: 'test',
      text_2: 'test',
      text_3: 'test',
      text_4: 'test',
      text_5: 'test',
      loadingDoc: null,
      minHeight: true,
      editionMode: false,
      test: 'test'
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.hasUpdate) {
      return this.$swal({
        title: 'Modification Programme',
        text: 'Vous êtes sur le point de quitter cette page. Souhaitez-vous enregistrer les modifications avant de quitter la page ?',
        confirmButtonText: 'Enregistrer et quitter',
        confirmButtonColor: '#81bc74',
        cancelButtonText: 'Quiter sans enregistrer',
        cancelButtonColor: '#ff0200',
        showCloseButton: true
      }).then(async r => {
        if (r.value) {
          try {
            await this.submit()
          } catch (e) {
            console.log(e)
            this.submitLoading = false
            this.loading = false
            this.$toasted.global.danger('Erreur lors de la mise à jour')
            return
          }
          next()
        } else if (r.dismiss === 'cancel') {
          next()
        }
      })
    } else {
      next()
    }
  },
  computed: {
    ...mapGetters(['isDistributeur', 'canUseBuyerSpace', 'canUseElectronicSign']),
    ...mapState(['currentUser', 'modal']),
    patchElement () {
      return this.patchProgram
    },
    documentEl () {
      return this.program
    },
    sortedContracts () {
      if (this.program && this.program.contracts) {
        let dates = cloneDeep(this.program.contracts)
        dates = dates.sort(function (a, b) {
          a = new Date(a.created_on)
          b = new Date(b.created_on)
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * -1
        })
        return dates
      } else {
        return []
      }
    },
    contractName () {
      if (this.program.contract_in_use != null) {
        let name = null
        for (let contract of this.program.contracts) {
          if (contract.pk === this.program.contract_in_use) {
            name = contract.name
          }
        }
        return name
      } else {
        return 'Contrat de Vadimm par défaut'
      }
    },
    nameToUse () {
      if (this.program && this.program.is_amenagement) {
        return 'lotissement'
      } else {
        return 'programme'
      }
    },
    sruCustomText () {
      return `<p>La loi vous offre une faculté de rétractation dans le délai de dix jours à compter du lendemain de la
      première présentation de cette lettre. Cette faculté de rétractation doit être exercée au domicile élu dans
      l’avant contrat, par lettre recommandée avec demande d’accusé de réception.</p>
      <p>En cas de rétractation, les fonds versés vous seront restitués dans un délai de vingt et un jours à
      compter du lendemain de la date de rétractation, sur présentation de la copie de la notification de rétractation et de l’avis de réception.</p>
      <p>Les dispositions de l’article L 271-1 du Code de la construction et de l’habitation sont ci-après littéralement
      rapportées :</p>
      <p>« Pour tout acte ayant pour objet la construction ou l’acquisition d’un immeuble à usage d’habitation,
      la souscription de parts donnant vocation à l’attribution en jouissance ou en propriété d’immeubles d’habitation ou la
      vente d’immeubles à construire ou de location-accession à la propriété immobilière, l’acquéreur non professionnel peut
      se rétracter dans un délai de dix jours à compter du lendemain de la première présentation de la lettre lui notifiant l’acte.</p>
      <p>Cet acte est notifié à l’acquéreur par lettre recommandée avec demande d’avis de réception ou par tout autre moyen
      présentant des garanties équivalentes pour la détermination de la date de réception ou de remise. La faculté de rétractation est exercée dans ces mêmes formes.</p>
      <p>Lorsque l’acte est conclu par l’intermédiaire d’un professionnel ayant reçu mandat pour prêter son concours à la vente,
      cet acte peut être remis directement au bénéficiaire du droit de rétractation. Dans ce cas, le délai de rétractation
      cours à compter du lendemain de la remise de l’acte, qui doit être attesté selon les modalités fixées par décret.</p>
      <p>Lorsque le contrat constatant ou réalisant la convention est précédé d’un contrat préliminaire ou d’une promesse
      synallagmatique ou unilatérale, les dispositions figurants aux trois alinéas précédents ne s’appliquent qu’à ce contrat ou cette promesse.</p>
      <p>Lorsque le contrat constatant ou réalisant la convention est dressé en la forme authentique et n’est pas précédé
      d’un contrat préliminaire ou d’une promesse synallagmatique ou unilatérale, l’acquéreur non professionnel dispose
      d’un délai de réflexion de dix jours à compter de la notification ou de la remise du projet d’acte selon les mêmes
      modalités que celles prévues pour le délai de rétractation mentionné aux premier et troisième alinéas. En aucun cas l’acte authentique ne peut être signé pendant ce délai de dix jours. »</p>`
    },
    firstSectionAdf () {
      return `<p>Lettre recommandée avec accusé de reception</p>`
    },
    homePageSection () {
      return `<p>Nous vous prions de trouver sous ce pli, copie de(s) attestation(s) de l'architecte de la résidence</p>`
    },
    stepName () {
      return `<p>indiquant que l'opération est au stade d'avancement des travaux suivant.</p>
            <p>Conformément à votre acquisition en l’état futur d’achèvement, vous trouverez ci-dessous le tableau
            de suivi de vos règlements.</p>`
    },
    amountStepAdf () {
      return `<p>En conséquence, nous vous remercions de bien vouloir nous faire parvenir votre
          règlement d'un </p>`
    }
  },
  watch: {
    modal ({ mode, params, results }) {
      if (results) {
        if (mode === 'CONTRACT_SELECT_MODAL') {
          this.program.contracts = results
          this.hasUpdate = true
        }
      }
    },
    'program.contracts' (v) {
      if (!this.blockWatch) {
        if (v && Array.isArray(v) && typeof v[0] === 'object') {
          let contractsId = v.map(x => x.pk)
          if (!contractsId.includes(this.useCustomContract)) {
            this.program.contract_in_use = null
            this.useCustomContract = null
          }
        } else if (v && Array.isArray(v) && typeof v[0] !== 'object') {
          if (!v.includes(this.useCustomContract)) {
            this.program.contract_in_use = null
            this.useCustomContract = null
          }
        }
      }
    }
  },
  created () {
    this.initView()
  },
  methods: {
    updateContractUsed (val) {
      this.useCustomContract = val
      this.hasUpdate = true
    },
    uploadPictures (files) {
      this.promoteur_custom_picture = [files[0]]
      this.program.program_params.promoteur_custom_picture = files[0]
      this.hasUpdate = true
    },
    deleteProgramParamsPicture () {
      this.promoteur_custom_picture = []
      this.program.program_params.promoteur_custom_picture = null
      this.hasUpdate = true
    },
    async patchProgram (patchedProgram, cb = null) {
      patchedProgram.force = true
      try {
        let { data } = await this.$api.patch(this.$resources.PROGRAM, this.program.pk, patchedProgram)
        this.$emit('updateProgram', data)
        if (cb && typeof cb === 'function') cb()
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    async initView () {
      this.id = this.$route.params.id

      await this.getProgram(this.id)
      if ('promoteur_custom_picture' in this.program.program_params && this.program.program_params.promoteur_custom_picture) {
        this.promoteur_custom_picture = [this.program.program_params.promoteur_custom_picture]
      }
      if (!('sru_custom_text' in this.program.program_params) || this.program.program_params.sru_custom_text == null) {
        this.program.program_params.sru_custom_text = this.sruCustomText
      }
      if (!('first_section_adf' in this.program.program_params) || this.program.program_params.first_section_adf == null) {
        this.program.program_params.first_section_adf = this.firstSectionAdf
      }
      if (!('home_page_section' in this.program.program_params) || this.program.program_params.home_page_section == null) {
        this.program.program_params.home_page_section = this.homePageSection
      }
      if (!('step_name' in this.program.program_params) || this.program.program_params.step_name == null) {
        this.program.program_params.step_name = this.stepName
      }
      if (!('amount_step_adf' in this.program.program_params) || this.program.program_params.amount_step_adf == null) {
        this.program.program_params.amount_step_adf = this.amountStepAdf
      }
      if (!('modality' in this.program.program_params) || this.program.program_params.modality == null) {
        const company = this.program.promoteur_data.company_name
        const promoteur = this.program.promoteur_data.rep_first_name + ' ' + this.program.promoteur_data.rep_last_name
        this.paymentModality = `<p>par :</p>
                          <p>- Chèque : à l’ordre de la société </p>
                          <p>- Virement : sur le compte bancaire dont vous trouverez ci-joint le RIB.</p>
                          <p>Dans cette attente, nous vous prions d'agréer, l'assurance de nos salutations distinguées.</p><br>
                          <p>Pour ${company}</p>
                          <p><strong>${promoteur}</strong></p>`

        this.program.program_params.modality = this.paymentModality
      }
      if (this.program.contract_in_use) {
        this.useCustomContract = this.program.contract_in_use
      }
      await this.$api.patch(this.$resources.PROGRAM, this.program.pk, { program_params: this.program.program_params })
      this.blockWatch = false
    },
    updateComment (value, key, secondaryKey) {
      if (secondaryKey) {
        if (key === 'program_params') {
          this.$set(this.program[key], secondaryKey, value, this.program.custom_adf = true)
        }
      } else {
        this.$set(this.program, key, value)
      }
      this.hasUpdate = true
    },
    beforeSubmit (program) {
      if (program.address && program.address.city) {
        program.address.city = program.address.city.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      }
      program.date_livraison = this.deliveryYear ? `${this.deliveryYear}${this.deliveryQuarter || '1'}` : null
      program.date_actabilite = this.actabilityYear ? `${this.actabilityYear}${this.actabilityQuarter || '1'}` : null
      program.promoteur = this.promoteur
      program.construction_data.debut_travaux = this.startWorkYear ? `${this.startWorkYear}${this.startWorkQuarter || '1'}` : null
      program.construction_data.fin_travaux = this.endWorkYear ? `${this.endWorkYear}${this.endWorkQuarter || '1'}` : null
      if (program.guaranteed_participation_fund === '') program.guaranteed_participation_fund = null
      if (program.fences_realisation === '') program.fences_realisation = null
      if (program.suez_installation === '') program.suez_installation = null
      program.contract_in_use = this.useCustomContract
      if (program.guaranteed_participation_fund === '') program.guaranteed_participation_fund = null
      if (program.fences_realisation === '') program.fences_realisation = null
      if (program.suez_installation === '') program.suez_installation = null
      if ('contracts' in program) {
        program.contracts = program.contracts.map(x => x.pk)
      }
      return program
    },
    async submit () {
      this.loading = true
      const updatedProgram = this.beforeSubmit(this.program)
      try {
        let { data } = await this.$api.put(this.$resources.PROGRAM, updatedProgram.pk, updatedProgram)
        this.program = data
        this.submitLoading = false
        this.loading = false
        this.hasUpdate = false
        this.$toasted.global.success('Document personnalisé du programme modifié')
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
        this.submitLoading = false
        this.hasUpdate = false
      }
    },
    async getProgram (id) {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.PROGRAM, id)
        this.program = data
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
        this.$router.replace({ name: 'NotFound' })
      }
    },
    async removeContract (pk) {
      this.hasUpdate = true
      const index = this.program.contracts.findIndex(x => x.pk === pk)
      if (index >= 0) {
        this.program.contracts.splice(index, 1)
      }
      // this.program.contracts.splice(index, 1)
    },
    async openPreviewContractSelect () {
      let params = {
        source: {
          currentContract: this.program.contracts
        }
      }
      this.$store.commit('setModal', { mode: 'CONTRACT_SELECT_MODAL', params })
    },
    /**
      * open document preview
      */
    async openPreview (buyerPk) {
      this.loadingDoc = true
      try {
        let request = await this.getPdf()
        let params = {
          // hasButton: this.adv.buyer_space_id,
          link: request.data
          // adf: this.step.construction_step
        }
        this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_ADF', params })
      } catch (err) {
        console.log(err)
      } finally {
        this.loadingDoc = false
      }
    },
    /**
      * get pdf
      * @returns {string} url
      */
    getPdf () {
      const payload = {
        'program': this.program.pk
      }
      let url = this.$api.axios.post(`/preview-adf`, payload)
      return url
    }
  }
}
</script>
